import * as PIXI from 'pixi.js';

export const getTextWidth = (text, style) => {
  return new PIXI.Text(text, style).width;
};
